import EventEmitter from 'eventemitter3';
import lodashMerge from 'lodash/merge';

import {assertDependencies, inherits} from '../lib/util';

export const EMIT = {
	vr_mode_change: 'vr_mode_change'
};

const MANIFEST = require('./manifest');

const DEFAULT_OPTIONS = {
	enabled: true,

	// How often to check for pano change
	update_interval: 1000,
};

function VrModeObserver(options = DEFAULT_OPTIONS, deps = MANIFEST.dependencies) {
	const thisVrModeObserver = this;
	EventEmitter.call(thisVrModeObserver);

	options = lodashMerge({}, DEFAULT_OPTIONS, options);
	assertDependencies(MANIFEST.name, MANIFEST.dependencies, deps);

	const log = deps.logger.child(MANIFEST.name);

	let _currentInVrMode = null;
	let _timeout = null;

	Object.assign(thisVrModeObserver, /** @lends VrModeObserver.prototype */ {
		init,
	});

	function init() {
		if (!options.enabled) {
			return log.warn(`Disabled through config parameter!`);
		}

		runUpdateTimer();
		update();
		log.verbose('Initialized');
	}

	function runUpdateTimer() {
		clearTimeout(_timeout);
		_timeout = setTimeout(() => {
			update();
			runUpdateTimer();
		}, options.update_interval);
	}

	function update() {
		if (!options.enabled || !deps.krPanoClient || !deps.krPanoClient.isReady()) {
			return;
		}

		const inVrMode = deps.krPanoClient.isInVrMode();
		if (inVrMode === _currentInVrMode) {
			return;
		}

		// The last argument is "isInitialState". It will be true only the first time we emit (during init)
		thisVrModeObserver.emit(EMIT.vr_mode_change, inVrMode, _currentInVrMode === null);

		if (inVrMode) {
			log.verbose(`Entered VR mode`);
		} else {
			log.verbose(`Exited VR mode`);
		}

		_currentInVrMode = inVrMode;
	}
}
inherits(VrModeObserver, EventEmitter);

// *********************************************************************************************************************

export default VrModeObserver;
